import { render } from "./ProductsFilterModal.vue?vue&type=template&id=7a87e2b0&scoped=true&ts=true"
import script from "./ProductsFilterModal.vue?vue&type=script&lang=ts"
export * from "./ProductsFilterModal.vue?vue&type=script&lang=ts"

import "./ProductsFilterModal.vue?vue&type=style&index=0&id=7a87e2b0&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/Bookit.BO/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a87e2b0"]])

export default __exports__